import type { DiscoverySource } from '../data/discovery';
import { ProviderArtwork } from './ProviderArtwork';

export interface ProviderAvatarsProps {
  sources: DiscoverySource[];
  /** avatar diameter in px (default 19) */
  size?: number;
  className?: string;
}

/** Overlapping public provider artwork, capped for dense catalog rows. */
export const ProviderAvatars = ({ sources, size = 19, className }: ProviderAvatarsProps) => {
  const shown = sources.slice(0, 4);
  return (
    <span className={`flex${className ? ` ${className}` : ''}`}>
      {shown.map((source, i) => {
        const marginLeft = i === 0 ? 0 : -6;
        return (
          <span
            key={source.id}
            className="grid place-items-center rounded-6 border-[1.5px] border-surface first:ml-0"
            style={{ width: size, height: size, marginLeft }}
          >
            <ProviderArtwork source={source} size={size} />
          </span>
        );
      })}
    </span>
  );
};
